import { render, staticRenderFns } from "./YesNoView.vue?vue&type=template&id=a2242aa0&scoped=true&"
import script from "./YesNoView.vue?vue&type=script&lang=js&"
export * from "./YesNoView.vue?vue&type=script&lang=js&"
import style0 from "./YesNoView.vue?vue&type=style&index=0&id=a2242aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2242aa0",
  null
  
)

export default component.exports